import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import ajaxStatuses from './ajax-statuses';
import user from './user';
import customerList from './customerList';
import payerList from './payerList';
import customerOrders from './customerOrders';
import balance from './balance';
import orderDetails from './orderDetails';
import myPerformance from './my-performance';
import performanceYears from './performance-years';
import customer from './customer';
import app from './app';
import customerCount from './customerTotalCount';
import notifications from './notifications';
import complaints from './complaints';
import complaintDetail from './complaint-detail';
import complaintYears from './complaint-years';


// complaints,
// complaintDetail,
// complaintYears,

export default combineReducers({
  app,
  ajaxStatuses,
  routing,
  user,
  customerList,
  payerList,
  customerOrders,
  balance,
  orderDetails,
  myPerformance,
  performanceYears,
  customerCount,
  customer,
  notifications,
  complaints,
  complaintYears,
  complaintDetail
});
